import { cloneElement, MouseEventHandler, ReactNode } from "react";
import styled from "styled-components";

const icons = {
  arrowLeft: (
    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 1L1 4.5L5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  arrowRight: (
    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 8L5 4.5L1 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  arrowDownNavbar: (
    <svg width="7" height="5" viewBox="0 0 7 5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.09038 4.41483L0.550711 0.786732C0.318739 0.455343 0.555815 2.81684e-07 0.960327 2.64002e-07L6.03967 4.19773e-08C6.44418 2.42955e-08 6.68126 0.455343 6.44929 0.786732L3.90962 4.41483C3.71056 4.69919 3.28943 4.69919 3.09038 4.41483Z"
        fill="currentColor"
      />
    </svg>
  ),
  arrowExternalLinkNavbar: (
    <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.22016 5.51016L6.19301 5.51015L6.19303 0.305491L0.787044 0.305485L0.78701 1.27829L4.57799 1.27829L1.38187 4.4744L2.05137 5.1439L5.22016 1.97511L5.22016 5.51016Z"
        fill="#FFFE3E"
      />
    </svg>
  ),
  ellipse: (
    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3" cy="3" r="3" fill="#1F0C19" />
    </svg>
  ),
  playButton: (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 30C60 13.4315 46.5685 5.55324e-07 30 3.57746e-07C13.4315 1.60169e-07 5.55324e-07 13.4315 3.57746e-07 30C1.60169e-07 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z"
        fill="#FFFE3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42 30L22 44L22 16L42 30ZM38.5124 30L24 40.1587L24 19.8413L38.5124 30Z"
        fill="#1F0C19"
      />
    </svg>
  ),
  expand: (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 30C60 13.4315 46.5685 5.55324e-07 30 3.57746e-07C13.4315 1.60169e-07 5.55324e-07 13.4315 3.57746e-07 30C1.60169e-07 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z"
        fill="#FFFE3E"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M44 16H33.2558V17.9535H42.0465V26.7442H44V16Z" fill="#1F0C19" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 44L26.7442 44L26.7442 42.0465L17.9535 42.0465L17.9535 33.2558L16 33.2558L16 44Z"
        fill="#1F0C19"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5654 26.0532L42.3329 16.2858L43.7142 17.6671L33.9468 27.4346L32.5654 26.0532Z"
        fill="#1F0C19"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2861 42.3325L35 23.6187L36.3813 25L17.6675 43.7139L16.2861 42.3325Z"
        fill="#1F0C19"
      />
    </svg>
  ),
  shareLink: (
    <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.25 10H5C3.58333 10 2.39583 9.52083 1.4375 8.5625C0.479167 7.60417 0 6.41667 0 5C0 3.58333 0.479167 2.39583 1.4375 1.4375C2.39583 0.479167 3.58333 0 5 0H9.25V1.5H5C4 1.5 3.16667 1.83333 2.5 2.5C1.83333 3.16667 1.5 4 1.5 5C1.5 6 1.83333 6.83333 2.5 7.5C3.16667 8.16667 4 8.5 5 8.5H9.25V10ZM6.125 5.75V4.25H13.875V5.75H6.125ZM10.75 10V8.5H15C16 8.5 16.8333 8.16667 17.5 7.5C18.1667 6.83333 18.5 6 18.5 5C18.5 4 18.1667 3.16667 17.5 2.5C16.8333 1.83333 16 1.5 15 1.5H10.75V0H15C16.4167 0 17.6042 0.479167 18.5625 1.4375C19.5208 2.39583 20 3.58333 20 5C20 6.41667 19.5208 7.60417 18.5625 8.5625C17.6042 9.52083 16.4167 10 15 10H10.75Z"
        fill="white"
      />
    </svg>
  ),
  arrowCircleLeft: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-6.55671e-07 15C-1.01779e-06 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 -2.93554e-07 15 -6.55671e-07C6.71573 -1.01779e-06 -2.93554e-07 6.71573 -6.55671e-07 15Z"
        fill="#FFFE3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6465 21.7071L16.3536 21L9.70718 14.3535L16.3536 7.70706L15.6465 6.99996L8.29297 14.3535L15.6465 21.7071Z"
        fill="#1F0C19"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 14.8535L9 14.8535L9 13.8535L21 13.8535L21 14.8535Z"
        fill="#1F0C19"
      />
    </svg>
  ),
  arrowCircleLeftClear: (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
      <g id="UI Buttons">
        <path
          id="Ellipse 47 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.5 15.5317C29.5 7.79975 23.232 1.53174 15.5 1.53174C7.76801 1.53174 1.5 7.79975 1.5 15.5317C1.5 23.2637 7.76801 29.5317 15.5 29.5317C23.232 29.5317 29.5 23.2637 29.5 15.5317ZM30.5 15.5317C30.5 7.24747 23.7843 0.531738 15.5 0.531738C7.21573 0.531738 0.5 7.24747 0.5 15.5317C0.5 23.816 7.21573 30.5317 15.5 30.5317C23.7843 30.5317 30.5 23.816 30.5 15.5317Z"
          fill="white"
        />
        <g id="Group 1431">
          <path
            id="Vector 9 (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1465 8.82458L16.8536 9.53169L10.2072 16.1781L16.8536 22.8246L16.1465 23.5317L8.79297 16.1781L16.1465 8.82458Z"
            fill="white"
          />
          <path
            id="Vector 111 (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5 15.6782L9.5 15.6782L9.5 16.6782L21.5 16.6782L21.5 15.6782Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  ),
  arrowCircleRight: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 15C30 6.71573 23.2843 -1.01779e-06 15 -6.55671e-07C6.71573 -2.93554e-07 -1.01779e-06 6.71573 -6.55671e-07 15C-2.93554e-07 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15Z"
        fill="#FFFE3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3535 8.29291L13.6464 9.00001L20.2929 15.6465L13.6464 22.2929L14.3535 23L21.7071 15.6465L14.3535 8.29291Z"
        fill="#1F0C19"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 15.1465L21 15.1465L21 16.1465L9 16.1465L9 15.1465Z"
        fill="#1F0C19"
      />
    </svg>
  ),
  arrowCircleDown: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 19.3333C15.1547 19.3333 19.3333 15.1547 19.3333 10C19.3333 4.84534 15.1547 0.666667 10 0.666667C4.84534 0.666667 0.666667 4.84534 0.666667 10C0.666667 15.1547 4.84534 19.3333 10 19.3333ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#FFFE3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9023 8.23569L14.4309 7.76429L9.99997 12.1953L5.56901 7.76429L5.0976 8.23569L9.99997 13.1381L14.9023 8.23569Z"
        fill="#FFFE3E"
      />
    </svg>
  ),
  loading: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      stroke="white"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="inherit"
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  ),
  expandDownCirlcle: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
        fill="#FFFE3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3535 12.3536L21.6464 11.6465L15 18.2929L8.35352 11.6465L7.64641 12.3536L15 19.7072L22.3535 12.3536Z"
        fill="#1F0C19"
      />
    </svg>
  ),
  checkCircleFilled: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.0646 13.481L13.7656 6.63974L12.2292 5.35937L7.93021 10.5181L5.70451 8.29245L4.2903 9.70667L8.0646 13.481Z"
        fill="#0CC76E"
      />
    </svg>
  ),
  cross: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 9.99957L9.99954 2M2 2.00043L9.9996 10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  crossCircleFilled: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM3.58579 13L4.29289 12.2929L7.58579 9L4.29289 5.70711L3.58579 5L5 3.58579L5.70711 4.29289L9 7.58579L12.2929 4.29289L13 3.58579L14.4142 5L13.7071 5.70711L10.4142 9L13.7071 12.2929L14.4142 13L13 14.4142L12.2929 13.7071L9 10.4142L5.70711 13.7071L5 14.4142L3.58579 13Z"
        fill="#F23F37"
      />
    </svg>
  ),
  crossCircleFilledWhite: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM5.95956 18.0404C5.56904 17.6499 5.56904 17.0168 5.95956 16.6262L10.5858 12L5.95956 7.37377C5.56904 6.98325 5.56904 6.35008 5.95956 5.95956C6.35008 5.56904 6.98325 5.56904 7.37377 5.95956L12 10.5858L16.6262 5.95956C17.0168 5.56904 17.6499 5.56904 18.0404 5.95956C18.431 6.35008 18.431 6.98325 18.0404 7.37377L13.4142 12L18.0404 16.6262C18.431 17.0168 18.431 17.6499 18.0404 18.0404C17.6499 18.431 17.0168 18.431 16.6262 18.0404L12 13.4142L7.37377 18.0404C6.98325 18.431 6.35008 18.431 5.95956 18.0404Z"
        fill="white"
      />
    </svg>
  ),
  anonUser: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7274 20.4471C19.2716 19.1713 18.2672 18.0439 16.8701 17.2399C15.4729 16.4358 13.7611 16 12 16C10.2389 16 8.52706 16.4358 7.12991 17.2399C5.73276 18.0439 4.72839 19.1713 4.27259 20.4471"
        stroke="white"
        strokeLinecap="round"
      />
      <circle cx="12" cy="8" r="4" stroke="white" strokeLinecap="round" />
    </svg>
  ),
  questionCircleFilled: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM11.0276 9.29309C10.4091 9.74613 9.84 10.163 9.84 10.93H8.02C7.992 10.874 7.964 10.818 7.95 10.748C7.908 10.622 7.88 10.482 7.88 10.3C7.88 9.22535 8.66048 8.67698 9.34042 8.19925C9.86515 7.83056 10.33 7.50395 10.33 7.01C10.33 6.52 9.84 6.03 9.07 6.03C8.44 6.03 8.006 6.31 7.726 6.59C7.558 6.758 7.418 6.94 7.32 7.15L5.5 6.31C5.668 5.876 5.906 5.498 6.228 5.162C6.802 4.588 7.656 4 9.07 4C11.24 4 12.57 5.33 12.57 6.87C12.57 8.16336 11.7638 8.75387 11.0276 9.29309ZM8.86 14.08C8.23 14.08 7.74 13.59 7.74 12.96C7.74 12.33 8.23 11.84 8.86 11.84C9.49 11.84 9.98 12.33 9.98 12.96C9.98 13.59 9.49 14.08 8.86 14.08Z"
        fill="white"
      />
    </svg>
  ),
  close: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72014 5.75188L14.6196 15.6514L15.3267 14.9443L5.42724 5.04477L4.72014 5.75188Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.42741 15.6513L15.3269 5.75183L14.6198 5.04472L4.72031 14.9442L5.42741 15.6513Z"
        fill="currentColor"
      />
    </svg>
  ),
  closeCircleFilled: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5024 12C24.5024 18.6274 19.1299 24 12.5024 24C5.87502 24 0.502441 18.6274 0.502441 12C0.502441 5.37258 5.87502 0 12.5024 0C19.1299 0 24.5024 5.37258 24.5024 12ZM12.5024 13.414L7.8763 18.0401L6.46208 16.6259L11.0882 11.9998L6.46192 7.37345L7.87613 5.95923L12.5024 10.5855L17.1287 5.95923L18.543 7.37345L13.9167 11.9998L18.5428 16.6259L17.1286 18.0401L12.5024 13.414Z"
        fill="white"
      />
    </svg>
  ),
  info: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.94704 11.3035H8.10419V7.10346H6.94704V11.3035ZM6.86133 5.47489C6.86133 5.81775 7.15276 6.11775 7.52133 6.11775C7.8899 6.11775 8.1899 5.81775 8.1899 5.47489C8.1899 5.13203 7.89847 4.83203 7.5299 4.83203C7.16133 4.83203 6.86133 5.13203 6.86133 5.47489Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50415 14.1184C10.8574 14.1184 13.5757 11.4001 13.5757 8.04688C13.5757 4.69367 10.8574 1.97536 7.50415 1.97536C4.15094 1.97536 1.43263 4.69367 1.43263 8.04688C1.43263 11.4001 4.15094 14.1184 7.50415 14.1184ZM7.50415 15.5469C11.6463 15.5469 15.0042 12.189 15.0042 8.04688C15.0042 3.90474 11.6463 0.546875 7.50415 0.546875C3.36202 0.546875 0.00415039 3.90474 0.00415039 8.04688C0.00415039 12.189 3.36202 15.5469 7.50415 15.5469Z"
        fill="currentColor"
      />
    </svg>
  ),
  muted: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 14.9995C29 7.26753 22.732 0.999512 15 0.999512C7.26801 0.999512 1 7.26752 1 14.9995C1 22.7315 7.26801 28.9995 15 28.9995C22.732 28.9995 29 22.7315 29 14.9995ZM30 14.9995C30 6.71524 23.2843 -0.000488004 15 -0.000488102C6.71573 -0.000488201 2.77662e-07 6.71524 1.78873e-07 14.9995C8.00843e-08 23.2838 6.71573 29.9995 15 29.9995C23.2843 29.9995 30 23.2838 30 14.9995Z"
        fill="white"
      />
      <path
        d="M7 13.1098V16.8927C7 17.4128 7.4 17.8384 7.88889 17.8384H10.5556L13.48 20.9498C14.04 21.5456 15 21.12 15 20.2783V9.71468C15 8.87299 14.04 8.44742 13.48 9.04322L10.5556 12.1641H7.88889C7.4 12.1641 7 12.5897 7 13.1098ZM19 15.0012C19 13.3273 18.0933 11.8898 16.7778 11.19V18.803C18.0933 18.1126 19 16.6751 19 15.0012ZM16.7778 7.86108V8.05022C16.7778 8.40959 17 8.72168 17.3111 8.85408C19.6044 9.82817 21.2222 12.2208 21.2222 15.0012C21.2222 17.7816 19.6044 20.1743 17.3111 21.1484C16.9911 21.2808 16.7778 21.5929 16.7778 21.9522V22.1414C16.7778 22.7372 17.3378 23.1533 17.8533 22.9452C20.8667 21.7253 23 18.6328 23 15.0012C23 11.3697 20.8667 8.27719 17.8533 7.05722C17.3378 6.83971 16.7778 7.26528 16.7778 7.86108V7.86108Z"
        fill="white"
      />
      <line x1="4.35355" y1="4.64596" x2="25.3536" y2="25.646" stroke="white" />
    </svg>
  ),
  unmuted: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 14.9995C29 7.26753 22.732 0.999512 15 0.999512C7.26801 0.999512 1 7.26752 1 14.9995C1 22.7315 7.26801 28.9995 15 28.9995C22.732 28.9995 29 22.7315 29 14.9995ZM30 14.9995C30 6.71524 23.2843 -0.000488004 15 -0.000488102C6.71573 -0.000488201 2.77662e-07 6.71524 1.78873e-07 14.9995C8.00843e-08 23.2838 6.71573 29.9995 15 29.9995C23.2843 29.9995 30 23.2838 30 14.9995Z"
        fill="white"
      />
      <path
        d="M7 13.1098V16.8927C7 17.4128 7.4 17.8384 7.88889 17.8384H10.5556L13.48 20.9498C14.04 21.5456 15 21.12 15 20.2783V9.71468C15 8.87299 14.04 8.44742 13.48 9.04322L10.5556 12.1641H7.88889C7.4 12.1641 7 12.5897 7 13.1098ZM19 15.0012C19 13.3273 18.0933 11.8898 16.7778 11.19V18.803C18.0933 18.1126 19 16.6751 19 15.0012ZM16.7778 7.86108V8.05022C16.7778 8.40959 17 8.72168 17.3111 8.85408C19.6044 9.82817 21.2222 12.2208 21.2222 15.0012C21.2222 17.7816 19.6044 20.1743 17.3111 21.1484C16.9911 21.2808 16.7778 21.5929 16.7778 21.9522V22.1414C16.7778 22.7372 17.3378 23.1533 17.8533 22.9452C20.8667 21.7253 23 18.6328 23 15.0012C23 11.3697 20.8667 8.27719 17.8533 7.05722C17.3378 6.83971 16.7778 7.26528 16.7778 7.86108V7.86108Z"
        fill="white"
      />
    </svg>
  ),
  gift: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.59904 3.1582H1.31484C0.818623 3.1582 0.570515 3.1582 0.416361 3.31236C0.262207 3.46651 0.262207 3.71462 0.262207 4.21083V4.73715C0.262207 5.23337 0.262207 5.48147 0.416361 5.63563C0.570515 5.78978 0.818622 5.78978 1.31484 5.78978H1.84115V5.91608H4.59904V3.1582ZM1.84115 6.71608V8.94768C1.84115 9.44389 1.84115 9.692 1.9953 9.84615C2.14946 10.0003 2.39757 10.0003 2.89378 10.0003H4.59904V6.71608H1.84115ZM5.39904 10.0003H7.10429C7.60051 10.0003 7.84862 10.0003 8.00277 9.84615C8.15692 9.692 8.15692 9.44389 8.15692 8.94768V6.71608H5.39904V10.0003ZM8.15692 5.91608V5.78978H8.68324C9.17945 5.78978 9.42756 5.78978 9.58171 5.63563C9.73587 5.48147 9.73587 5.23337 9.73587 4.73715V4.21083C9.73587 3.71462 9.73587 3.46651 9.58171 3.31236C9.42756 3.1582 9.17945 3.1582 8.68324 3.1582H5.39904V5.91608H8.15692Z"
        fill="#1F0C19"
      />
      <path
        d="M8.68408 1.3855V1.28965C8.68408 0.655196 8.06251 0.207192 7.46061 0.407825C6.70766 0.658808 6.02349 1.08165 5.46228 1.64287L4.99988 2.10526V2.63158H6.93432C7.04746 2.63158 7.15986 2.61334 7.26719 2.57756L8.00126 2.33287C8.40903 2.19695 8.68408 1.81534 8.68408 1.3855Z"
        fill="#1F0C19"
      />
      <path
        d="M1.31836 1.3855V1.28965C1.31836 0.655196 1.93993 0.207192 2.54183 0.407825C3.29478 0.658808 3.97895 1.08165 4.54016 1.64287L5.00256 2.10526V2.63158H3.06812C2.95498 2.63158 2.84258 2.61334 2.73525 2.57756L2.00118 2.33287C1.59341 2.19695 1.31836 1.81534 1.31836 1.3855Z"
        fill="#1F0C19"
      />
    </svg>
  ),
  separator: (
    <svg width="48" height="4" viewBox="0 0 48 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0L1 4" stroke="#4D3D48" />
      <path d="M3 0L3 4" stroke="#4D3D48" />
      <path d="M5 0L5 4" stroke="#4D3D48" />
      <path d="M7 0L7 4" stroke="#4D3D48" />
      <path d="M9 0L9 4" stroke="#4D3D48" />
      <path d="M11 0L11 4" stroke="#4D3D48" />
      <path d="M13 0L13 4" stroke="#4D3D48" />
      <path d="M15 0L15 4" stroke="#4D3D48" />
      <path d="M17 0L17 4" stroke="#4D3D48" />
      <path d="M19 0L19 4" stroke="#4D3D48" />
      <path d="M21 0L21 4" stroke="#4D3D48" />
      <path d="M23 0L23 4" stroke="#4D3D48" />
      <path d="M21 0L21 4" stroke="#4D3D48" />
      <path d="M25 0L25 4" stroke="#4D3D48" />
      <path d="M27 0L27 4" stroke="#4D3D48" />
      <path d="M31 0L31 4" stroke="#4D3D48" />
      <path d="M33 0L33 4" stroke="#4D3D48" />
      <path d="M35 0L35 4" stroke="#4D3D48" />
      <path d="M37 0L37 4" stroke="#4D3D48" />
      <path d="M39 0L39 4" stroke="#4D3D48" />
      <path d="M41 0L41 4" stroke="#4D3D48" />
      <path d="M43 0L43 4" stroke="#4D3D48" />
      <path d="M45 0L45 4" stroke="#4D3D48" />
      <path d="M47 0L47 4" stroke="#4D3D48" />
      <path d="M29 0L29 4" stroke="#4D3D48" />
    </svg>
  ),
  headshot: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5.00107" cy="4.99997" r="3.59091" stroke="white" />
      <line x1="5.04688" y1="7.27271" x2="5.04688" y2="9.99998" stroke="white" />
      <line x1="10" y1="5.04541" x2="7.27273" y2="5.04541" stroke="white" />
      <line x1="8.18359" y1="5.04541" x2="0.00177574" y2="5.04541" stroke="white" />
      <line x1="5.04688" y1="-2.40413e-08" x2="5.04688" y2="8.18182" stroke="white" />
    </svg>
  ),
  blastCoin: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.31368 4.96093L9.37593 2.69994L11.7012 7.64596L8.31368 4.96093ZM8.9211 8.91375L8.34292 7.68519L7.71363 9.02634L5.44302 9.23701L7.28066 5.32704L10.6682 8.01208L11.0008 8.72125L8.9211 8.91375ZM13.5 13.4999L11.6579 9.57908L9.57729 9.77249L10.3957 11.5141H7.60339L8.36982 9.88417L6.1001 10.0948L4.5 13.4999H13.5Z"
        fill="inherit"
      />
    </svg>
  ),
  chatVipProductIcon: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1360_94501)">
        <path
          d="M4 2C4 0.895431 4.89543 0 6 0H22C23.1046 0 24 0.895431 24 2V18C24 19.1046 23.1046 20 22 20H6C4.89543 20 4 19.1046 4 18V2Z"
          fill="currentColor"
        />
        <path
          d="M9.26484 14H14.148H18.7352C18.8865 14 19.0141 13.8873 19.0328 13.7372L19.8915 6.86761C19.927 6.58417 19.5837 6.41628 19.3817 6.61827L17.2446 8.75541C17.1155 8.8845 16.902 8.86933 16.7925 8.72328L14.24 5.32C14.12 5.16 13.88 5.16 13.76 5.32L11.2075 8.72328C11.098 8.86933 10.8845 8.8845 10.7554 8.75541L8.61827 6.61827C8.41628 6.41628 8.07302 6.58417 8.10845 6.86761L8.96715 13.7372C8.98592 13.8873 9.11354 14 9.26484 14Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1360_94501"
          x="0"
          y="0"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1360_94501" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1360_94501" result="shape" />
        </filter>
      </defs>
    </svg>
  ),
  twitter: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" viewBox="0 0 512 512">
      <path d="M459.4 151.7c.3 4.5 .3 9.1 .3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103v-1.3c14 7.8 30.2 12.7 47.4 13.3-28.3-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z" />
    </svg>
  ),
  discord: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="#FFFFFF">
      <path d="M524.5 69.8a1.5 1.5 0 0 0 -.8-.7A485.1 485.1 0 0 0 404.1 32a1.8 1.8 0 0 0 -1.9 .9 337.5 337.5 0 0 0 -14.9 30.6 447.8 447.8 0 0 0 -134.4 0 309.5 309.5 0 0 0 -15.1-30.6 1.9 1.9 0 0 0 -1.9-.9A483.7 483.7 0 0 0 116.1 69.1a1.7 1.7 0 0 0 -.8 .7C39.1 183.7 18.2 294.7 28.4 404.4a2 2 0 0 0 .8 1.4A487.7 487.7 0 0 0 176 479.9a1.9 1.9 0 0 0 2.1-.7A348.2 348.2 0 0 0 208.1 430.4a1.9 1.9 0 0 0 -1-2.6 321.2 321.2 0 0 1 -45.9-21.9 1.9 1.9 0 0 1 -.2-3.1c3.1-2.3 6.2-4.7 9.1-7.1a1.8 1.8 0 0 1 1.9-.3c96.2 43.9 200.4 43.9 295.5 0a1.8 1.8 0 0 1 1.9 .2c2.9 2.4 6 4.9 9.1 7.2a1.9 1.9 0 0 1 -.2 3.1 301.4 301.4 0 0 1 -45.9 21.8 1.9 1.9 0 0 0 -1 2.6 391.1 391.1 0 0 0 30 48.8 1.9 1.9 0 0 0 2.1 .7A486 486 0 0 0 610.7 405.7a1.9 1.9 0 0 0 .8-1.4C623.7 277.6 590.9 167.5 524.5 69.8zM222.5 337.6c-29 0-52.8-26.6-52.8-59.2S193.1 219.1 222.5 219.1c29.7 0 53.3 26.8 52.8 59.2C275.3 311 251.9 337.6 222.5 337.6zm195.4 0c-29 0-52.8-26.6-52.8-59.2S388.4 219.1 417.9 219.1c29.7 0 53.3 26.8 52.8 59.2C470.7 311 447.5 337.6 417.9 337.6z" />
    </svg>
  ),
  reddit: (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 30 30">
      <path
        d="M 17.662109 2 C 15.565005 2 14 3.7131367 14 5.6621094 L 14 9.0351562 C 11.24971 9.1810926 8.7344872 9.9143634 6.7265625 11.064453 C 5.9527826 10.321405 4.9166871 9.991448 3.9121094 9.9921875 C 2.8229214 9.9929893 1.7094525 10.370413 0.94140625 11.234375 L 0.92382812 11.253906 L 0.90625 11.273438 C 0.16947928 12.194228 -0.12225605 13.427747 0.07421875 14.652344 C 0.25365009 15.770711 0.90137168 16.893419 2.0273438 17.628906 C 2.0199689 17.753058 2 17.874618 2 18 C 2 22.962 7.832 27 15 27 C 22.168 27 28 22.962 28 18 C 28 17.874618 27.980031 17.753058 27.972656 17.628906 C 29.098628 16.893419 29.74635 15.770711 29.925781 14.652344 C 30.122256 13.427747 29.830521 12.194228 29.09375 11.273438 L 29.076172 11.253906 L 29.058594 11.234375 C 28.290448 10.370294 27.177168 9.9929893 26.087891 9.9921875 C 25.08323 9.991448 24.046988 10.321133 23.273438 11.064453 C 21.265513 9.9143634 18.75029 9.1810926 16 9.0351562 L 16 5.6621094 C 16 4.6830821 16.565214 4 17.662109 4 C 18.182797 4 18.817104 4.2609042 19.810547 4.609375 C 20.650361 4.9039572 21.743308 5.2016984 23.140625 5.2910156 C 23.474875 6.2790874 24.402814 7 25.5 7 C 26.875 7 28 5.875 28 4.5 C 28 3.125 26.875 2 25.5 2 C 24.561213 2 23.747538 2.5304211 23.320312 3.3007812 C 22.125831 3.2346294 21.248238 2.9947078 20.472656 2.7226562 C 19.568849 2.4056271 18.738422 2 17.662109 2 z M 3.9121094 11.992188 C 4.3072494 11.991896 4.6826692 12.095595 4.9921875 12.263672 C 3.8881963 13.18517 3.0505713 14.261821 2.5449219 15.4375 C 2.2764358 15.106087 2.114647 14.734002 2.0507812 14.335938 C 1.9430146 13.664243 2.1440212 12.966045 2.4628906 12.552734 C 2.7642172 12.228395 3.3144613 11.992626 3.9121094 11.992188 z M 26.085938 11.992188 C 26.683756 11.992627 27.235874 12.22849 27.537109 12.552734 C 27.855979 12.966045 28.056985 13.664243 27.949219 14.335938 C 27.885353 14.734002 27.723564 15.106087 27.455078 15.4375 C 26.949429 14.261821 26.111804 13.18517 25.007812 12.263672 C 25.316626 12.095792 25.690955 11.991896 26.085938 11.992188 z M 10 14 C 11.105 14 12 14.895 12 16 C 12 17.105 11.105 18 10 18 C 8.895 18 8 17.105 8 16 C 8 14.895 8.895 14 10 14 z M 20 14 C 21.105 14 22 14.895 22 16 C 22 17.105 21.105 18 20 18 C 18.895 18 18 17.105 18 16 C 18 14.895 18.895 14 20 14 z M 20.238281 19.533203 C 19.599281 21.400203 17.556 23 15 23 C 12.444 23 10.400719 21.400969 9.7617188 19.667969 C 10.911719 20.600969 12.828 21.267578 15 21.267578 C 17.172 21.267578 19.088281 20.600203 20.238281 19.533203 z"
        fill="#FFFFFF"
      />
    </svg>
  ),
  graph: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="currentColor">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4 2.53125H17.6C17.8209 2.53125 18 2.71034 18 2.93125V18.1313C18 18.3522 17.8209 18.5312 17.6 18.5312H2.4C2.17909 18.5312 2 18.3522 2 18.1313V2.93125C2 2.71034 2.17909 2.53125 2.4 2.53125ZM0 2.93125C0 1.60577 1.07452 0.53125 2.4 0.53125H17.6C18.9255 0.53125 20 1.60577 20 2.93125V18.1313C20 19.4567 18.9255 20.5312 17.6 20.5312H2.4C1.07452 20.5312 0 19.4567 0 18.1313V2.93125ZM15.9429 6.06537C16.1273 5.54477 15.8547 4.97327 15.3341 4.7889C14.8135 4.60452 14.242 4.87708 14.0576 5.39768L11.3127 13.1481L8.49035 9.04287C7.82866 8.08041 6.3488 8.30361 6.00042 9.41843L4.24579 15.0332C4.08105 15.5604 4.37485 16.1213 4.90199 16.286C5.42914 16.4507 5.99001 16.1569 6.15475 15.6298L7.54133 11.1927L10.3316 15.2513C10.9796 16.1938 12.4231 16.0037 12.8049 14.9255L15.9429 6.06537Z"
      />
    </svg>
  ),
  profile: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
      />
    </svg>
  ),
  trophy: (
    <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.53125V6.93125C6 9.14039 7.79086 10.9312 10 10.9312C12.2091 10.9312 14 9.14039 14 6.93125V2.53125H6ZM4 3.53125H2V4.53125C2 5.76118 2.85401 6.79165 4.0014 7.062C4.00047 7.01853 4 6.97494 4 6.93125V3.53125ZM4.00711 1.53125H1.4C0.626801 1.53125 0 2.15805 0 2.93125V4.53125C0 7.0097 1.9601 9.03035 4.41472 9.12758C5.1736 11.0559 6.90225 12.4964 9 12.8483L9 18.5312H4.4C3.84772 18.5312 3.4 18.979 3.4 19.5312C3.4 20.0835 3.84772 20.5312 4.4 20.5312L15.6 20.5313C16.1523 20.5313 16.6 20.0835 16.6 19.5313C16.6 18.979 16.1523 18.5313 15.6 18.5313H11L11 12.8483C13.0978 12.4964 14.8264 11.0559 15.5853 9.12758C18.0399 9.03034 20 7.0097 20 4.53125V2.93125C20 2.15805 19.3732 1.53125 18.6 1.53125H15.9929C15.9297 0.968593 15.4523 0.53125 14.8727 0.53125H5.12727C4.54773 0.53125 4.07033 0.968593 4.00711 1.53125ZM18 4.53125C18 5.76118 17.146 6.79164 15.9986 7.062C15.9995 7.01853 16 6.97495 16 6.93125V3.53125H18V4.53125Z"
      />
    </svg>
  ),
  captain: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9487 10.5313C17.9487 14.9212 14.39 18.48 10 18.48C5.61004 18.48 2.05128 14.9212 2.05128 10.5313C2.05128 6.14129 5.61004 2.58253 10 2.58253C14.39 2.58253 17.9487 6.14129 17.9487 10.5313ZM20 10.5313C20 16.0541 15.5228 20.5313 10 20.5313C4.47715 20.5313 0 16.0541 0 10.5313C0 5.0084 4.47715 0.53125 10 0.53125C15.5228 0.53125 20 5.0084 20 10.5313ZM11.9142 12.808C12.1669 12.6183 12.4003 12.3906 12.6141 12.1439L13.9751 13.3772C13.6834 13.7378 13.3529 14.0413 12.9641 14.326C12.2836 14.8003 11.3115 15.2747 9.98943 15.2747C7.26754 15.2747 5.12891 13.1875 5.12891 10.5311C5.12891 7.87468 7.26754 5.7875 9.98943 5.7875C11.3115 5.7875 12.2836 6.24288 12.9252 6.69827C13.2946 6.96391 13.6251 7.2675 13.8778 7.59006L12.5169 8.8234C12.3419 8.59571 12.1281 8.38699 11.8753 8.21622C11.4281 7.91263 10.8254 7.59006 9.98943 7.59006C8.33685 7.59006 7.07312 8.80442 7.07312 10.5311C7.07312 12.2578 8.33685 13.4721 9.98943 13.4721C10.8254 13.4721 11.467 13.1685 11.9142 12.808Z"
        fill="inherit"
      />
    </svg>
  ),
  carry: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_1230)">
        <rect
          x="26.1553"
          y="80.4082"
          width="18.9771"
          height="39.8519"
          rx="6"
          transform="rotate(45 26.1553 80.4082)"
          fill="#FF2C6B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.5975 9.07758C81.4701 6.62881 84.2133 4.99462 87.2582 4.51383L112.609 0.511029C116.633 -0.124328 120.107 3.34944 119.472 7.37338L115.469 32.7245C114.988 35.7694 113.354 38.5126 110.905 40.3852L57.6901 81.079L71.563 94.952C73.9062 97.2951 73.9062 101.094 71.563 103.437L69.3132 105.687C66.9701 108.03 63.1711 108.03 60.828 105.687L14.296 59.1551C11.9529 56.8119 11.9529 53.0129 14.296 50.6698L16.5458 48.42C18.889 46.0769 22.6879 46.0769 25.0311 48.42L38.9037 62.2926L79.5975 9.07758ZM48.3203 71.7092L48.274 71.6629C46.4443 69.8083 46.452 66.8217 48.297 64.9767L92.5792 20.6946C94.432 18.8418 97.4359 18.8418 99.2886 20.6946C101.141 22.5473 101.141 25.5512 99.2886 27.404L55.0065 71.6861C53.1614 73.5312 50.1748 73.5388 48.3203 71.7092Z"
          fill="#FF2C6B"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_1230">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  midlaner: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_1231)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.547 30.407L119.509 7.6106C120.22 3.51986 116.661 -0.0391055 112.571 0.671843L89.7742 4.63375C85.7829 5.3274 84.2303 10.2309 87.0948 13.0954L93.5219 19.5226L87.8509 25.1935C66.2645 7.06075 34.4894 7.29328 13.1643 25.8911C12.3633 26.5897 11.1513 26.5734 10.3997 25.8219C9.37204 24.7942 7.70583 24.7942 6.67814 25.8219L2.17497 30.325C1.0034 31.4966 1.0034 33.3961 2.17497 34.5677L9.22877 41.6215L18.0244 95.0201L2.67508 110.369C0.722452 112.322 0.722447 115.488 2.67507 117.44C4.6277 119.393 7.79352 119.393 9.74614 117.44L25.0483 102.138L78.5598 110.952L85.6136 118.006C86.7851 119.178 88.6846 119.178 89.8562 118.006L94.3594 113.503C95.3871 112.475 95.3871 110.809 94.3594 109.782C93.6078 109.03 93.5915 107.818 94.2901 107.017C112.908 85.6684 113.121 53.8466 94.9277 32.259L100.593 26.5936L107.086 33.0864C109.95 35.9509 114.854 34.3982 115.547 30.407ZM77.1891 35.8554C61.4736 23.465 39.0325 23.7425 23.6182 36.6878L31.0766 81.9679L77.1891 35.8554ZM38.1005 89.0861L84.2679 42.9187C96.7171 58.6377 96.4589 81.1247 83.4935 96.563L38.1005 89.0861Z"
          fill="#41A4FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_1231">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  offlaner: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_1232)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60 120C80 120 120 93.1371 120 60V9.98923C120 4.46639 115.537 1.56659e-05 110.014 1.29897e-05L60 0L9.9883 1.39457e-05C4.46545 1.69348e-05 6.71417e-06 4.46927 1.35719e-05 9.99212L4.8399e-05 60C4.8399e-05 93.1371 40 120 60 120ZM62.847 19H76.5781C78.9066 19 80.3474 21.5371 79.1546 23.5368L66.6649 44.4754C65.8697 45.8086 66.8303 47.5 68.3825 47.5H79.0209C80.7282 47.5 81.6505 49.5014 80.5414 50.7993L40.0501 98.1827C39.3231 99.0335 37.9608 98.2301 38.3534 97.1822L51.6484 61.7018C52.1383 60.3944 51.1717 59 49.7755 59H40.0029C38.4683 59 37.5054 57.3429 38.2654 56.0096L57.6344 22.0288C58.7018 20.1562 60.6916 19 62.847 19Z"
          fill="#B061FE"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_1232">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  softSupport: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_1228)">
        <rect y="71.9968" width="20" height="42" rx="6" fill="#FFA902" />
        <path
          d="M25 103.876V81.4968C25 78.1831 27.6863 75.4968 31 75.4968H31.33C37.6851 75.4968 43.9488 77.0111 49.6021 79.9141L50.8979 80.5795C56.5512 83.4826 62.8149 84.9968 69.17 84.9968H79C82.3137 84.9968 85 87.6831 85 90.9968C85 94.3105 82.3137 96.9968 79 96.9968H53.5C51.8431 96.9968 50.5 98.34 50.5 99.9968C50.5 101.654 51.8431 102.997 53.5 102.997H80.3712C85.9652 102.997 90.5 98.462 90.5 92.868C90.5 91.7292 91.1679 90.6963 92.2064 90.229L99.3707 87.005C106.07 83.9904 113.935 85.432 119.13 90.6265C120.546 92.0428 120.167 94.429 118.382 95.3371L79.8725 114.924C69.7688 120.063 57.9592 120.673 47.3793 116.604L28.8461 109.476C26.529 108.585 25 106.359 25 103.876Z"
          fill="#FFA902"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M90 41.9969C90 58.0132 77.0163 70.9969 61 70.9969C44.9837 70.9969 32 58.0132 32 41.9969C32 32.9012 36.1874 24.7836 42.7396 19.4666C43.3113 19.0027 44.1719 19.3355 44.3878 20.0394C44.9869 21.9933 46.2029 24.8153 48.2401 27.1779C48.6293 27.6292 49.3242 27.5919 49.6332 27.0822C51.9824 23.2061 54.0306 14.084 47.5638 1.46651C47.1699 0.697916 47.8336 -0.196609 48.6647 0.0382845C59.7765 3.17876 78.4208 13.7311 79.4602 35.7422C79.4904 36.3811 80.0871 36.8406 80.6756 36.5901C82.1833 35.9484 84.4614 34.6002 86.7326 32.2369C87.255 31.6933 88.1818 31.8393 88.4273 32.5522C89.4466 35.5128 90 38.6902 90 41.9969ZM72.0037 49.7617C72.0037 56.519 66.636 61.997 60.0147 61.997C53.3933 61.997 48.0257 56.519 48.0257 49.7617C47.7392 43.6216 49.7045 34.7992 61.4366 30.7941C62.33 30.4891 63.0876 31.5571 62.6374 32.3869C60.9431 35.5098 59.4927 40.0585 61.3651 43.7477C61.6101 44.2304 62.2333 44.3688 62.667 44.0451C63.5241 43.4055 64.3657 42.4365 64.8741 40.1254C65.0086 39.514 65.6341 39.1286 66.1862 39.4237C68.6067 40.7175 72.0037 43.9453 72.0037 49.7617Z"
          fill="#FFA902"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_1228">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  hardSupport: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_1229)">
        <rect y="71.9968" width="20" height="42" rx="6" fill="#54FFE0" />
        <path
          d="M25 103.876V81.4968C25 78.1831 27.6863 75.4968 31 75.4968H31.33C37.6851 75.4968 43.9488 77.0111 49.6021 79.9141L50.8979 80.5795C56.5512 83.4826 62.8149 84.9968 69.17 84.9968H79C82.3137 84.9968 85 87.6831 85 90.9968C85 94.3105 82.3137 96.9968 79 96.9968H53.5C51.8431 96.9968 50.5 98.34 50.5 99.9968C50.5 101.654 51.8431 102.997 53.5 102.997H80.3712C85.9652 102.997 90.5 98.462 90.5 92.868C90.5 91.7292 91.1679 90.6963 92.2064 90.229L99.3707 87.005C106.07 83.9904 113.935 85.432 119.13 90.6265C120.546 92.0428 120.167 94.429 118.382 95.3371L79.8725 114.924C69.7688 120.063 57.9592 120.673 47.3793 116.604L28.8461 109.476C26.529 108.585 25 106.359 25 103.876Z"
          fill="#54FFE0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.625 19.625C42.625 18.1753 41.4497 17 40 17C38.5503 17 37.375 18.1753 37.375 19.625V20.3409C37.375 28.644 30.644 35.375 22.3409 35.375H21.625C20.1753 35.375 19 36.5503 19 38C19 39.4497 20.1753 40.625 21.625 40.625H22.3409C30.644 40.625 37.375 47.356 37.375 55.6591V56.375C37.375 57.8247 38.5503 59 40 59C41.4497 59 42.625 57.8247 42.625 56.375V55.6591C42.625 47.356 49.356 40.625 57.6591 40.625H58.375C59.8247 40.625 61 39.4497 61 38C61 36.5503 59.8247 35.375 58.375 35.375H57.6591C49.356 35.375 42.625 28.644 42.625 20.3409V19.625Z"
          fill="#54FFE0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.375 1.375C73.375 0.615609 72.7594 0 72 0C71.2406 0 70.625 0.615608 70.625 1.375V1.75C70.625 6.09924 67.0992 9.625 62.75 9.625H62.375C61.6156 9.625 61 10.2406 61 11C61 11.7594 61.6156 12.375 62.375 12.375H62.75C67.0992 12.375 70.625 15.9008 70.625 20.25V20.625C70.625 21.3844 71.2406 22 72 22C72.7594 22 73.375 21.3844 73.375 20.625V20.25C73.375 15.9008 76.9008 12.375 81.25 12.375H81.625C82.3844 12.375 83 11.7594 83 11C83 10.2406 82.3844 9.625 81.625 9.625H81.25C76.9008 9.625 73.375 6.09924 73.375 1.75V1.375Z"
          fill="#54FFE0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.125 40.125C85.125 38.9514 84.1736 38 83 38C81.8264 38 80.875 38.9514 80.875 40.125V40.7045C80.875 47.4261 75.4261 52.875 68.7045 52.875H68.125C66.9514 52.875 66 53.8264 66 55C66 56.1736 66.9514 57.125 68.125 57.125H68.7045C75.4261 57.125 80.875 62.5739 80.875 69.2955V69.875C80.875 71.0486 81.8264 72 83 72C84.1736 72 85.125 71.0486 85.125 69.875V69.2955C85.125 62.5739 90.5739 57.125 97.2955 57.125H97.875C99.0486 57.125 100 56.1736 100 55C100 53.8264 99.0486 52.875 97.875 52.875H97.2955C90.5739 52.875 85.125 47.4261 85.125 40.7045V40.125Z"
          fill="#54FFE0"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_1229">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  dotaLaneJungle: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.0493 44.8903C87.6467 44.8903 88.5995 43.11 87.7134 41.7809L61.5236 2.49607C60.7319 1.3086 58.987 1.3086 58.1954 2.49607L32.0054 41.7809C31.1194 43.11 32.0722 44.8903 33.6695 44.8903H51.5818C52.6864 44.8903 53.5818 45.7857 53.5818 46.8903V117.708C53.5818 118.812 54.4772 119.708 55.5818 119.708H64.1479C65.2524 119.708 66.1479 118.812 66.1479 117.708V46.8903C66.1479 45.7858 67.0433 44.8903 68.1479 44.8903H86.0493ZM33.6716 72.9468C35.269 72.9468 36.2218 71.1665 35.3357 69.8374L20.3684 47.3865C19.5768 46.199 17.8318 46.199 17.0402 47.3865L2.07291 69.8374C1.18683 71.1665 2.13961 72.9468 3.737 72.9468H12.7937C13.8983 72.9468 14.7937 73.8422 14.7937 74.9468L14.7937 117.708C14.7937 118.812 15.6891 119.708 16.7937 119.708H20.6475C21.752 119.708 22.6475 118.812 22.6475 117.708V74.9468C22.6475 73.8422 23.5429 72.9468 24.6475 72.9468H33.6716ZM99.6315 47.3865C100.423 46.199 102.168 46.199 102.96 47.3865L117.927 69.8374C118.813 71.1665 117.86 72.9468 116.263 72.9468H107.239C106.134 72.9468 105.239 73.8422 105.239 74.9468V117.708C105.239 118.812 104.343 119.708 103.239 119.708H99.385C98.2804 119.708 97.385 118.812 97.385 117.708V74.9468C97.385 73.8422 96.4896 72.9468 95.385 72.9468H86.3283C84.7309 72.9468 83.7782 71.1665 84.6642 69.8374L99.6315 47.3865Z"
        fill="#54FFE0"
      />
    </svg>
  ),
  dotaLaneRoaming: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.8046 26.8522C88.0416 27.6378 88.0416 29.4432 86.8046 30.2288L47.5957 55.1298C46.2641 55.9754 44.5234 55.0188 44.5234 53.4415V36.5324C44.5234 35.4278 43.628 34.5324 42.5234 34.5324L14.9839 34.5324C13.8793 34.5324 12.9839 35.4278 12.9839 36.5324V80.4698C12.9839 81.5744 12.0884 82.4698 10.9839 82.4698H3C1.89543 82.4698 1 81.5744 1 80.4698V24.5505C1 23.4459 1.89543 22.5505 3 22.5505H5.57491C5.57544 22.5505 5.57587 22.55 5.57587 22.5495C5.57587 22.549 5.57629 22.5485 5.57682 22.5485L42.5235 22.5485C43.628 22.5485 44.5235 21.6531 44.5235 20.5485V3.63947C44.5235 2.06211 46.2641 1.10554 47.5957 1.95117L86.8046 26.8522ZM33.6181 93.1479C32.381 92.3623 32.381 90.5569 33.6181 89.7713L72.827 64.8703C74.1585 64.0247 75.8992 64.9813 75.8992 66.5586V83.4677C75.8992 84.5723 76.7946 85.4677 77.8992 85.4677H105.439C106.543 85.4677 107.439 84.5723 107.439 83.4677L107.439 39.5303C107.439 38.4257 108.334 37.5303 109.439 37.5303H117.423C118.527 37.5303 119.423 38.4257 119.423 39.5303V95.4497C119.423 96.5542 118.527 97.4497 117.423 97.4497L114.848 97.4497C114.847 97.4497 114.847 97.4501 114.847 97.4506C114.847 97.4511 114.846 97.4516 114.846 97.4516L77.8992 97.4516C76.7946 97.4516 75.8992 98.347 75.8992 99.4516V116.361C75.8992 117.938 74.1585 118.895 72.827 118.049L33.6181 93.1479Z"
        fill="#FFA902"
      />
    </svg>
  ),
  dotaLaneSafe: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3917 55.2311C42.389 56.4995 45 55.0647 45 52.6986V38.5789C45 36.9221 46.3432 35.5789 48 35.5789H117C118.657 35.5789 120 34.2358 120 32.5789V26.5789C120 24.9221 118.657 23.5789 117 23.5789H48C46.3431 23.5789 45 22.2358 45 20.5789V6.4592C45 4.09316 42.389 2.6583 40.3917 3.92676L3.98757 27.0465C2.132 28.2249 2.132 30.9329 3.98758 32.1114L40.3917 55.2311ZM79.6083 115.231C77.611 116.5 75 115.065 75 112.699V98.5789C75 96.9221 73.6569 95.5789 72 95.5789H3C1.34315 95.5789 0 94.2358 0 92.5789V86.5789C0 84.9221 1.34315 83.5789 3 83.5789H72C73.6569 83.5789 75 82.2358 75 80.5789V66.4592C75 64.0932 77.611 62.6583 79.6083 63.9268L116.012 87.0465C117.868 88.2249 117.868 90.9329 116.012 92.1114L79.6083 115.231Z"
        fill="#41A4FF"
      />
    </svg>
  ),
  dotaLaneOff: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8906 2.65838C28.6762 1.42133 30.4816 1.42133 31.2672 2.65838L56.2066 41.9278C57.0523 43.2593 56.0957 45 54.5183 45H37.5789C36.4743 45 35.5789 45.8954 35.5789 47V118C35.5789 119.105 34.6835 120 33.5789 120H25.5789C24.4743 120 23.5789 119.105 23.5789 118L23.5789 47C23.5789 45.8954 22.6835 45 21.5789 45H4.63947C3.06211 45 2.10554 43.2593 2.95117 41.9278L27.8906 2.65838ZM87.9023 117.342C88.6879 118.579 90.4933 118.579 91.2789 117.342L116.218 78.0722C117.064 76.7407 116.107 75 114.53 75H97.5906C96.486 75 95.5906 74.1046 95.5906 73V2C95.5906 0.895431 94.6952 0 93.5906 0H85.5906C84.486 0 83.5906 0.895429 83.5906 2V73C83.5906 74.1046 82.6952 75 81.5906 75H64.6512C63.0738 75 62.1173 76.7407 62.9629 78.0722L87.9023 117.342Z"
        fill="#FF2C6B"
      />
    </svg>
  ),
  dotaLaneMid: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_578_22704)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M118.586 7.11296C119.367 7.89401 119.367 9.16034 118.586 9.94139L102.228 26.2994C101.447 27.0804 101.447 28.3467 102.228 29.1278L114.285 41.1846C115.4 42.3 114.846 44.2072 113.306 44.5508L67.6465 54.741C66.2162 55.0602 64.9397 53.7837 65.2589 52.3534L75.4491 6.69366C75.7927 5.15417 77.7 4.59973 78.8153 5.71509L90.8723 17.7721C91.6534 18.5532 92.9197 18.5532 93.7008 17.7721L110.059 1.41416C110.84 0.633106 112.106 0.633107 112.887 1.41416L118.586 7.11296ZM52.3539 65.246C53.7841 64.9268 55.0607 66.2033 54.7415 67.6336L44.5512 113.293C44.2077 114.833 42.3004 115.387 41.1851 114.272L29.128 102.215C28.347 101.434 27.0806 101.434 26.2996 102.215L9.94163 118.573C9.16059 119.354 7.89425 119.354 7.11321 118.573L1.4144 112.874C0.633351 112.093 0.633351 110.827 1.4144 110.046L17.7724 93.6876C18.5534 92.9066 18.5534 91.6403 17.7724 90.8592L5.71556 78.8024C4.6002 77.687 5.15465 75.7798 6.69414 75.4362L52.3539 65.246Z"
          fill="#B061FE"
        />
      </g>
      <defs>
        <clipPath id="clip0_578_22704">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  magnifyingGlass: (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.067 6.88677C10.067 9.11441 8.26114 10.9203 6.0335 10.9203C3.80586 10.9203 2 9.11441 2 6.88677C2 4.65913 3.80586 2.85327 6.0335 2.85327C8.26114 2.85327 10.067 4.65913 10.067 6.88677ZM9.5885 11.7622C8.59149 12.4905 7.36269 12.9203 6.0335 12.9203C2.70129 12.9203 0 10.219 0 6.88677C0 3.55456 2.70129 0.853271 6.0335 0.853271C9.36571 0.853271 12.067 3.55456 12.067 6.88677C12.067 8.16774 11.6678 9.35547 10.987 10.3323L14.0944 13.4397C14.485 13.8303 14.485 14.4634 14.0944 14.854C13.7039 15.2445 13.0707 15.2445 12.6802 14.854L9.5885 11.7622Z"
        fill="inherit"
      />
    </svg>
  ),
  closeCircled: (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58 30C58 14.536 45.464 2 30 2C14.536 2 2 14.536 2 30C2 45.464 14.536 58 30 58C45.464 58 58 45.464 58 30ZM60 30C60 13.4315 46.5685 5.55324e-07 30 3.57746e-07C13.4315 1.60169e-07 5.55324e-07 13.4315 3.57746e-07 30C1.60169e-07 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8075 40.6066L40.6064 20.8076L39.1922 19.3934L19.3932 39.1924L20.8075 40.6066Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6066 39.1923L20.8076 19.3933L19.3934 20.8075L39.1924 40.6065L40.6066 39.1923Z"
        fill="white"
      />
    </svg>
  ),
  burgerMenu: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 3.85C20 3.38056 19.6195 3 19.15 3H3.85003C3.38058 3 3.00003 3.38056 3.00003 3.85C3.00003 4.31944 3.38058 4.7 3.85003 4.7H19.15C19.6195 4.7 20 4.31944 20 3.85ZM20 11.5C20 11.0305 19.6195 10.65 19.15 10.65H3.85003C3.38058 10.65 3.00003 11.0305 3.00003 11.5C3.00003 11.9694 3.38058 12.35 3.85003 12.35H19.15C19.6195 12.35 20 11.9694 20 11.5ZM3 19.15C3 18.6806 3.38056 18.3 3.85 18.3H12.1155C12.585 18.3 12.9655 18.6806 12.9655 19.15C12.9655 19.6195 12.585 20 12.1155 20H3.85C3.38056 20 3 19.6195 3 19.15Z"
        fill="white"
      />
    </svg>
  ),
};

export type IconName = keyof typeof icons;

interface IconProps {
  icon: IconName;
  className?: string;
  onClick?: () => void;
}

function Icon({ icon, className, onClick }: IconProps) {
  const el = icons[icon] as JSX.Element;
  const classNames = [el.props.className, className].filter((c) => c);

  return cloneElement(el, {
    className: `${classNames.join(" ")}`,
    onClick,
  });
}

const StyledIconWrapperButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

interface IconWrapperButtonProps {
  children: ReactNode;
  onClick: MouseEventHandler;
  label: string;
}

type IconButtonProps = IconProps & Omit<IconWrapperButtonProps, "children">;

export function IconWrapperButton({ children, label, onClick }: IconWrapperButtonProps) {
  return (
    <StyledIconWrapperButton aria-label={label} onClick={onClick} type="button">
      {children}
    </StyledIconWrapperButton>
  );
}

export function IconButton({ label, onClick, ...iconProps }: IconButtonProps) {
  return (
    <IconWrapperButton label={label} onClick={onClick}>
      <Icon {...iconProps} />
    </IconWrapperButton>
  );
}
export { Icon };
